// extracted by mini-css-extract-plugin
module.exports = {"main":"main-module--main--3lKgP"};